import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import { feedbackApiCall } from '../api/feedback.api';
import type {RootState} from './store';

//import axios from 'axios';

interface feedbackState {
  feedback:string;
  loading: boolean;
  error: string;
  data: string;
}

// Define the initial state using that type
const initialState: feedbackState = {
    feedback:'',
    loading: false,
  error: '',
  data: '',
};

export const feedbackCustomer = createAsyncThunk(
  'feedback',
  async (parameters: any, thunkApi) => {
    return feedbackApiCall(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const feebackCustomerSlice = createSlice({
  name: 'feedback',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(feedbackCustomer.pending, state => {
      state.loading = true;
    });
    builder.addCase(feedbackCustomer.fulfilled, (state, action) => {
      state.data = 'SUCCESS';
      state.loading = false;
      console.log(state.data);
    });
    builder.addCase(feedbackCustomer.rejected, (state, action) => {
      console.log('action====>', action);
      state.error = action.toString();

      state.loading = false;
    });
  },
});

//Other code such as selectors can use the imported `RootState` type
export const {resetState} = feebackCustomerSlice.actions;


export const error = (state: RootState): string => state.feedbackCustomerReducer.error;
export const loading = (state: RootState): boolean =>
  state.feedbackCustomerReducer.loading;
  export const feedbackStatus = (state: RootState): string =>
  state.feedbackCustomerReducer.data;



export default feebackCustomerSlice.reducer;
